import React, { useState, useRef, useEffect } from 'react';
import styles from './Nav.module.css';

function Nav() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [labelStyles, setLabelStyles] = useState({});
  const [activeSection, setActiveSection] = useState('home');
  const [isMobile, setIsMobile] = useState(false);
  const navbarRef = useRef(null);

  const navItems = [
    { id: 'home', icon: '/icons/home.png', label: 'Home' },
    { id: 'projects', icon: '/icons/folder.png', label: 'Projects' },
    { id: 'experience', icon: '/icons/suitcase.png', label: 'Experience' },
    { id: 'tools', icon: '/icons/skills.png', label: 'Tools' },
    { id: 'blogs', icon: '/icons/blogger.png', label: 'Blogs' },
    { id: 'resume', icon: '/icons/download (1).png', label: 'Resume', download: true },
  ];

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Hover label position (desktop only)
  const handleMouseEnter = (itemId, event) => {
    if (isMobile) return;
    setHoveredItem(itemId);
    if (navbarRef.current) {
      const navbarRect = navbarRef.current.getBoundingClientRect();
      const itemRect = event.currentTarget.getBoundingClientRect();
      setLabelStyles({
        top: navbarRect.bottom + 15,
        left: itemRect.left + itemRect.width / 2
      });
    }
  };

  const handleMouseLeave = () => setHoveredItem(null);

  const handleClick = (itemId, download) => (e) => {
    if (download) return; // resume download
    e.preventDefault();
    const target = document.getElementById(itemId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Active section highlighting
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'projects', 'experience', 'tools', 'blogs', 'contact'];
      let current = 'home';
      sections.forEach(id => {
        const section = document.getElementById(id);
        if (section && window.scrollY >= section.offsetTop - 80) {
          current = id;
        }
      });
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`${styles.navContainer} ${isMobile ? styles.mobileNav : ''}`}>
      <nav ref={navbarRef}>
        <ul>
          {navItems.map(item => (
            <li
              key={item.id}
              className={activeSection === item.id ? styles.active : ''}
              onMouseEnter={(e) => handleMouseEnter(item.id, e)}
              onMouseLeave={handleMouseLeave}
            >
              {item.download ? (
                <a href="/resume.pdf" download="Abinesh_Resume.pdf">
                  <img src={item.icon} alt={item.label} />
                </a>
              ) : (
                <a href={`#${item.id}`} onClick={handleClick(item.id, item.download)}>
                  <img src={item.icon} alt={item.label} />
                  {isMobile && (
                    <span className={styles.mobileLabel}>{item.label}</span>
                  )}
                </a>
              )}

              {!isMobile && hoveredItem === item.id && (
                <span
                  className={styles.navLabel}
                  style={{
                    top: `${labelStyles.top}px`,
                    left: `${labelStyles.left}px`
                  }}
                >
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default Nav;
